import axiosInstance from 'api/axiosInstance';
import { DocumentReferenceField } from 'types/repository.types';

const getRepoDocumentFields = (
  repoDocumentId: string,
): Promise<DocumentReferenceField[]> =>
  axiosInstance.get(`/v2/repository-documents/${repoDocumentId}/fields`);

export default getRepoDocumentFields;
